import React, { useEffect, useState } from 'react';
import TransactionsTable from "../../components/table/transactions-table";
import { NewTransactionsTable } from "../../components/table/NewTransactionsTable/NewTransactionsTable";
import { useTranslation } from "react-i18next";
import { Get } from "../../apis/api";
import { Separate } from "../../utils/separate";
import { useSelector } from "react-redux";

const Transactions = () => {
  const { t } = useTranslation()
  const [walletDeposit, setWalletDeposit] = useState(null)
  const [loading, setLoading] = useState(false)
  const user = useSelector((state) => state.user.user)
  
  const isAdmin = user?.role_key === "super_admin"
  useEffect(() => {
    if (user?.role_key === "client" || user?.role_key === "agent")
      handleDeposit()
  }, [])
  const handleDeposit = (page, per_page, search = "") => {
    setLoading(true)
    Get(`agent/transactions/wallets/deposit`).then((res) => {
      setWalletDeposit(res?.details?.data)
    }).finally(() => {
      setLoading(false)
    })
  }
  return (
    <div className={"my-container flex flex-col gap-4 mb-10"}>
      {!isAdmin &&  <><div className={" bg-white rounded-lg flex flex-col gap-4 w-full overflow-hidden py-5 text-center"}>
        <span className={"text-primary-500 text-3xl font-medium"}>{Separate(walletDeposit?.amount)}</span>
        <span className={"text-gray-500 text-2xl"}>{t("walletBalance")}</span>
      </div></>}
      <span className={"font-normal text-lg text-primary-400"}>
        {t("transactionHistory")}
      </span>

      
     {isAdmin ?   <NewTransactionsTable/> : <TransactionsTable/>}
    </div>
  );
};

export default Transactions;
